var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu-redirect"},[_c('div',{staticClass:"kefu-box"},[_c('div',{staticClass:"loading-icon"},[_c('div',{staticClass:"spinner"})]),_c('p',{staticClass:"tips"},[_vm._v("正在进入客服通道...")]),_c('p',{staticClass:"sub-tips"},[_vm._v("请稍候")])])])
}]

export { render, staticRenderFns }